import { useMemo } from "react";
import type { DefaultOptionType } from "@rc-component/select/lib/Select";

/**
 * Ensures the current value's option is present in the list.
 * If the current option is already in the list, returns the list as-is.
 * If not (e.g. the item was deleted and filtered from the query), prepends it.
 */
export const useOptionsWithCurrent = <T>(
  items: readonly T[] | null | undefined,
  current: T | null | undefined,
  mapper: (item: T) => DefaultOptionType,
): DefaultOptionType[] =>
  useMemo(() => {
    const options = (items ?? []).map(mapper);
    if (!current) return options;
    const currentOption = mapper(current);
    if (options.some((o) => o.value === currentOption.value)) return options;
    return [currentOption, ...options];
  }, [items, current, mapper]);
